<template>
    <footer>
        <div class="built-with">
            <p>built with</p>
            <a href="https://vuejs.com"><img alt="Vue logo" src="../assets/logo.png"></a>
        </div>
    </footer>
</template>

<script>
export default {
    
}
</script>

<style scoped>
footer {
    min-height:20vh;
    background-color:var(--prim-c);
    color:var(--sec-c);
    padding:50px 20px;
}

footer .built-with {
    display:flex;
    flex-direction: column;
    align-content: center;
    max-width:100px;
}

footer .built-with a {
    margin:0;    
}

footer .built-with a img {
    height:100%;
    width:100%;   
    max-height:45px;
    max-width:45px; 
}

</style>

